import { Link } from '@tanstack/react-router';
import type { Sessione } from '../api/sessione.js';
import { etichettaLivello } from '../etichette.js';
import { t } from '../i18n/lingua.js';
import { SeApre } from '../componenti/SeApre.js';

/**
 * Il mio lavoro.
 *
 * Non è una dashboard e non finge di esserlo: la dashboard è fuori perimetro
 * e va riprogettata con chi la userà, quindi qui non ci sono riquadri con
 * numeri messi lì per riempire. C'è quello che serve per cominciare la
 * giornata — le due porte da cui si passa sempre — e la verità su a che punto
 * è il programma.
 */
export function Home({ sessione }: { sessione: Sessione }) {
  const azienda = sessione.user.companies.find((a) => a.id === sessione.companyId);

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">{t('Il mio lavoro')}</h1>
          <div className="page-sub">
            {sessione.user.name} · {etichettaLivello(sessione.user.accessLevel)}
            {azienda ? ` · ${azienda.name}` : ''}
          </div>
        </div>
      </div>

      {/* le porte da cui si passa sempre — quelle che il livello apre */}
      <div className="scorciatoie">
        <SeApre sezione="sales-orders">
          <Link className="scorciatoia" to="/sales-orders">
            <span className="scorciatoia-nome">{t('Ordini di vendita')}</span>
            <span className="dim">{t('Dove si passa la giornata')}</span>
          </Link>
          <Link className="scorciatoia" to="/alerts">
            <span className="scorciatoia-nome">{t('Avvisi')}</span>
            <span className="dim">{t('Le date d’arrivo che si sono spostate')}</span>
          </Link>
        </SeApre>
        <SeApre sezione="negotiations">
          <Link className="scorciatoia" to="/negotiations">
            <span className="scorciatoia-nome">{t('Trattative')}</span>
            <span className="dim">{t('Le proposte in corso')}</span>
          </Link>
        </SeApre>
        <SeApre sezione="documents">
          <Link className="scorciatoia" to="/documents">
            <span className="scorciatoia-nome">{t('Documenti')}</span>
            <span className="dim">{t('Fatture, DDT, prove di consegna')}</span>
          </Link>
        </SeApre>
        <SeApre sezione="production">
          <Link className="scorciatoia" to="/production">
            <span className="scorciatoia-nome">{t('Da confermare')}</span>
            <span className="dim">{t('Gli ordini da portare allo stato 2')}</span>
          </Link>
        </SeApre>
      </div>

      <div className="cantiere">
        <h2>{t('A che punto siamo')}</h2>
        {/* riscritto dopo il passaggio del 24 ottobre 2026: prima diceva che i
            file dei documenti sarebbero arrivati «il giorno del passaggio» */}
        <p>
          {t(
            'Il CRM 3.0 ha preso il posto del vecchio. Tutto quello che sta nel menu lavora sui dati veri, portati dal vecchio CRM: anagrafiche, articoli, listini, ordini, documenti con i loro file, trattative, avvisi e vettori.',
          )}
        </p>
        <p>
          {t('Se qualcosa non torna rispetto al vecchio CRM, segnalatelo subito: si corregge in giornata.')}
        </p>
      </div>
    </>
  );
}
